export default "__VITE_PUBLIC_ASSET__0819745f__"